import React from 'react'
import { connect } from 'react-redux'
import SizeActions from '../../Redux/SizeRedux'
import CategoryActions from '../../Redux/CategoryRedux'
import { currentBranch } from '../../Utils/PrivilegeUtils'

class CreateSize extends React.Component {
  constructor (props) {
    super(props)
    this.branch = currentBranch()
    this.state = {
      size: {
        name: '',
        category_id: ''
      }
    }
  }

  componentDidMount = () => {
    this.props.getCategory()
  }

  _inputChange = (event, field) => {
    let value = event.target.value
    let size = { ...this.state.size }
    size[field] = value
    this.setState({ size })
  }

  _submit = (event) => {
    event.preventDefault()
    let data = { ...this.state.size }
    data.iso_code = this.branch
    this.props.createSize(data)
    setTimeout(() => { this.props.closeModal() }, 250)
  }

  render () {
    const { category } = this.props
    return (
      <div className='section' style={{ width: '40vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>Subtype Creation</h4>
        </div>
        <form onSubmit={(event) => this._submit(event)}>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>For Category</label>
            </div>
            <div className='col-9'>
              <select className='form-control' onChange={event => this._inputChange(event, 'category_id')}>
                <option>--Pick a Category--</option>
                {
                  category.data && category.data.map((item, i) => {
                    return (
                      <option key={i} value={item.id}>
                        {item.name}
                      </option>
                    )
                  })
                }
              </select>
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Subtype</label>
            </div>
            <div className='col-9'>
              <input
                type='text'
                required
                placeholder='Insert subtype name'
                className='form-control'
                value={this.state.size.name}
                onChange={(event) => this._inputChange(event, 'name')}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-12 text-right'>
              <button type='button' className='btn btn-secondary mr-2' onClick={() => this.props.closeModal()}>Cancel</button>
              <button type='submit' className='btn btn-primary'>Save</button>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  category: state.category
})

const dispatchToProps = (dispatch) => ({
  getCategory: (data) => dispatch(CategoryActions.getCategoryRequest(data)),
  createSize: (data) => dispatch(SizeActions.createSizeRequest(data))
})

export default connect(stateToProps, dispatchToProps)(CreateSize)



// WEBPACK FOOTER //
// ./src/Containers/Ecommerce/CreateSize.js